// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"84e0f1f8","607":"e2889b76","810":"c19f0538","834":"9a35711d"}[chunkId] + ".chunk.js";
};